// ////////url: http://localhost:3000/Addprojects/add/join //////////////////////////////////////////////
import React, { useState, useEffect, useMemo } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useridchecks, lastjoinafter } from '../../service/project';
import MetaTag from "../../MetaTag";
import { metaInfoForProjectAddWritePage } from "../../service/mataTags";
import Swal from 'sweetalert2';
import { Input, Button } from 'antd';
import { MailOutlined, UserOutlined, LockOutlined } from '@ant-design/icons';

function Addprojectsjoin({ uid, setCookieIds, getCookieIds }) {
  // write 페이지에서 state 로 넘어온 projectdata 가져오기
  const location = useLocation();
  const projectData = (location.state && location.state.projectData) || {};
  const [addUser, setAddUser] = useState({
    email: projectData.email || '',
    userId: '',
    uPassword: '',
    uNewPassword: ''
  });
  // projectData.email 이 바뀔 수 있는 경우
  useEffect(() => {
    if (projectData.email) {
      setAddUser(prev => ({ ...prev, email: projectData.email }));
    }
  }, [projectData.email]);

  const [pass, setPass] = useState(false);
  const [check, setCheck] = useState(false);
  const [idcheck, setIdCheck] = useState(false);
  const navigate = useNavigate();

  // ===================== Leave Guard (가입 전 이탈 방지) =====================
  // 가입 성공 전까지 항상 가드 ON (조인 페이지일 때)
  const onJoin = useMemo(() => location.pathname.endsWith('/add/join'), [location.pathname]);
  const [guardEnabled, setGuardEnabled] = useState(true);

  useEffect(() => {
    const enabled = onJoin && guardEnabled;
    if (!enabled) return;

    const pushState = () => window.history.pushState({ guard: true }, '', window.location.href);
    pushState();

    let releasing = false;

    const cleanup = () => {
      window.removeEventListener('popstate', handlePopState);
      document.removeEventListener('click', handleDocClick, true);
      // window.removeEventListener('beforeunload', handleBeforeUnload);
    };

    const confirmLeave = async () => {
      const ok = await Swal.fire({
        title: '페이지 이동을 하시겠습니까?',
        html: `
          <span style="color: #6c63ff; font-weight: bold; font-size:16px;">
            회원가입을 해야 프로젝트 내용에 대해 확인 하실 수 있습니다.
          </span>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '나가기',
        cancelButtonText: '계속 작성',
        reverseButtons: true,
        focusCancel: true,
        heightAuto: false,
      }).then(r => r.isConfirmed);
      return ok;
    };

    // 1) 브라우저 뒤로가기
    const handlePopState = () => {
      if (releasing) return;
      Promise.resolve().then(async () => {
        const ok = await confirmLeave();
        if (!ok) {
          pushState(); // 취소: 현재 위치 유지
        } else {
          releasing = true;
          cleanup();
          window.history.back();
        }
      });
    };
    window.addEventListener('popstate', handlePopState);

    // 2) 내부 링크 클릭 가로채기
    const handleDocClick = (e) => {
      const t = e.target;
      const a = t && typeof t.closest === 'function' ? t.closest('a[href]') : null;
      if (!a) return;

      const href = a.getAttribute && a.getAttribute('href');
      if (!href) return;
      if (a.target === '_blank') return;            // 새창 허용
      if (/^https?:\/\//i.test(href)) return;       // 외부 링크 허용
      if (href.startsWith('#')) return;             // 해시 이동 무시

      const target = new URL(href, window.location.origin);
      if (
        target.pathname === window.location.pathname &&
        target.search === window.location.search &&
        target.hash === window.location.hash
      ) return;

      e.preventDefault();
      (async () => {
        const ok = await confirmLeave();
        if (ok) {
          releasing = true;
          cleanup();
          window.location.assign(target.pathname + target.search + target.hash);
        }
      })();
    };
    document.addEventListener('click', handleDocClick, true);

    // 3) 탭/창 닫기(주소창 이동 포함)
    // const handleBeforeUnload = (e) => {
    //   e.preventDefault();
    //   e.returnValue = ''; // 네이티브 경고
    // };
    // window.addEventListener('beforeunload', handleBeforeUnload);

    return cleanup;
  }, [onJoin, guardEnabled]);
  // ========================================================================

  const handleChange = (id, value) => {
    setAddUser(prev => ({ ...prev, [id]: value }));
  };

  const useridCheck = e => {
    e.preventDefault();
    if (!addUser.userId) return Swal.fire('아이디를 입력해주세요');
    useridchecks(addUser.userId)
      .then(res => {
        if (res.data) {
          Swal.fire('이미 등록된 아이디 입니다', '확인', 'error');
        } else {
          Swal.fire('사용가능한 아이디 입니다', '확인', 'success');
          setIdCheck(true);
        }
      })
    // .catch(console.log);
  };

  const removeUidFromCookies = u => {
    const existing = getCookieIds();
    setCookieIds(existing.filter(id => id !== u));
  };

  const registration = e => {
    e.preventDefault();
    if (!addUser.email) return Swal.fire('이메일을 입력해주세요');
    if (!addUser.userId) return Swal.fire('아이디를 입력해주세요');
    if (!addUser.uPassword) return Swal.fire('비밀번호를 입력해주세요');
    if (!addUser.uNewPassword) return Swal.fire('비밀번호확인을 입력해주세요');
    if (!check) return Swal.fire('체크박스에 동의해주세요');
    if (!idcheck) return Swal.fire('아이디를 중복확인 해주세요');

    lastjoinafter(
      addUser.uPassword,           // uPassword
      addUser.email,               // email
      addUser.userId,              // userId
      projectData.client,          // uName (담당자명)
      projectData.clientphone,     // uPhone (연락처)
      projectData.company,         // company (회사명)
      projectData.clientaddress,   // companyaddressf (회사주소)
      '',                          // companyaddressm (상세주소 비워둠)
      uid                          // uid
    )
      .then(res => {
        if (res.data) {
          Swal.fire('회원가입이 완료 되었습니다', '확인', 'success');
          removeUidFromCookies(uid);
          // ✅ 가입 성공: 가드 해제 후 이동
          setGuardEnabled(false);
          navigate(`/Addprojects/add/fine?uid=${uid}`);
        }
      })
    // .catch(console.log);
  };

  const regPass = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{6,25}$/;
  const regEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return (
    <div style={{ display: 'flex', gap: 20, padding: 20 }}>
      {/* 왼쪽: 폼 */}
      <div style={{ flex: 1 }}>
        <MetaTag {...metaInfoForProjectAddWritePage} />
        <form>
          <div style={{ borderBottom: "2px solid rgba(16,36,148,0.1)", marginBottom: 20 }}>
            <h3 className='clientInfo_title'>회원 가입</h3>
          </div>

          {/* E-mail */}
          <Input
            prefix={<MailOutlined />}
            placeholder="E-mail"
            value={addUser.email}
            onChange={e => handleChange('email', e.target.value)}
            style={{ flex: 1, height: '50px', fontSize: '18px', paddingTop: 0, paddingBottom: 0, marginBottom: '8px' }}
          />
          {!regEmail.test(addUser.email) && (
            <p className='passerror'>이메일 형식을 확인해주세요</p>
          )}

          {/* ID + 중복확인 */}
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
            <Input
              prefix={<UserOutlined />}
              placeholder="ID"
              value={addUser.userId}
              onChange={e => handleChange('userId', e.target.value)}
              style={{ flex: 1, height: '50px', fontSize: '18px', paddingTop: 0, paddingBottom: 0, marginBottom: '8px' }}
            />
            <Button
              type="primary"
              onClick={useridCheck}
              style={{
                marginLeft: '8px',
                height: '50px',
                fontSize: '18px',
                marginTop: '-10px'
              }}
            >
              중복확인
            </Button>
          </div>

          {/* Password */}
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Password"
            value={addUser.uPassword}
            onClick={() => setPass(true)}
            onChange={e => handleChange('uPassword', e.target.value)}
            style={{ flex: 1, height: '50px', fontSize: '18px', paddingTop: 0, paddingBottom: 0, marginBottom: '8px' }}
          />
          {pass && (
            <p className={regPass.test(addUser.uPassword) ? 'pass_success' : 'passerror'}>
              영문/숫자/특수문자 조합(6~20자){regPass.test(addUser.uPassword) && ' ○'}
            </p>
          )}

          {/* Password 확인 */}
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Password 확인"
            value={addUser.uNewPassword}
            onChange={e => handleChange('uNewPassword', e.target.value)}
            style={{ flex: 1, height: '50px', fontSize: '18px', paddingTop: 0, paddingBottom: 0, marginBottom: '8px' }}
          />
          {addUser.uNewPassword.length > 1 && (
            addUser.uPassword === addUser.uNewPassword
              ? <p className='pass_success'>비밀번호가 일치합니다</p>
              : <p className='passerror'>비밀번호가 일치하지 않습니다</p>
          )}

          <label style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
            <input type='checkbox' checked={check} onChange={e => setCheck(e.target.checked)} />
            <span style={{ marginLeft: 8, fontSize: '18px', fontWeight: 'bold' }}>동의하시겠습니까</span>
          </label>

          <div style={{ display: 'flex', gap: 10, marginTop: 40, justifyContent: 'center' }}>
            <button
              type='submit'
              className='navibtn_hover p10'
              onClick={registration}
            >
              회원가입
            </button>
            {/*
            // ▼ "다음에 가입하기"를 쓰고 싶다면 가드 해제 후 이동
            <Link
              className='navibtn_hover p10'
              onClick={() => {
                removeUidFromCookies(uid);
                setGuardEnabled(false); // 가드 해제
              }}
              to={`/Addprojects/add/fine?uid=${uid}`}
            >
              다음에 가입하기
            </Link>
            */}
          </div>
        </form>
      </div>

      {/* 오른쪽: 미리보기 */}
      <div style={{ flex: 1, borderLeft: '1px solid #ddd', paddingLeft: 20 }}>
        {/* 타이틀 */}
        <div style={{ borderBottom: "2px solid rgba(16,36,148,0.1)", marginBottom: 20 }}>
          <h3 className='clientInfo_title'>입력 정보</h3>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
          {/* 담당자명 */}
          <div>
            <p style={{ margin: '0 0 4px', fontWeight: 'bold', fontSize: '18px' }}>담당자명</p>
            <div style={{
              height: '50px',
              lineHeight: '50px',
              padding: '0 12px',
              border: '1px solid #d9d9d9',
              borderRadius: '4px',
              fontSize: '18px',
              background: '#fafafa'
            }}>
              {projectData.client || ''}
            </div>
          </div>

          {/* 연락처 */}
          <div>
            <p style={{ margin: '0 0 4px', fontWeight: 'bold', fontSize: '18px' }}>연락처</p>
            <div style={{
              height: '50px',
              lineHeight: '50px',
              padding: '0 12px',
              border: '1px solid #d9d9d9',
              borderRadius: '4px',
              fontSize: '18px',
              background: '#fafafa'
            }}>
              {projectData.clientphone || ''}
            </div>
          </div>

          {/* 회사명 */}
          <div>
            <p style={{ margin: '0 0 4px', fontWeight: 'bold', fontSize: '18px' }}>회사명</p>
            <div style={{
              height: '50px',
              lineHeight: '50px',
              padding: '0 12px',
              border: '1px solid #d9d9d9',
              borderRadius: '4px',
              fontSize: '18px',
              background: '#fafafa'
            }}>
              {projectData.company || ''}
            </div>
          </div>

          {/* 회사 주소 */}
          <div>
            <p style={{ margin: '0 0 4px', fontWeight: 'bold', fontSize: '18px' }}>회사 주소</p>
            <div style={{
              height: '50px',
              lineHeight: '50px',
              padding: '0 12px',
              border: '1px solid #d9d9d9',
              borderRadius: '4px',
              fontSize: '18px',
              background: '#fafafa',
            }}>
              {projectData.clientaddress || ''}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Addprojectsjoin;
